var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page" }, [
    _c(
      "h3",
      { staticClass: "fc-text-sm fc-color-gray-light fc-pad-t-big fc-pad" },
      [_vm._v(_vm._s(_vm.$t("m.common-problem")))]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "fc-text-usual fc-bg-fff fc-pad fc-pad-t-sm fc-color-gray-dark"
      },
      [
        _c("p", { staticClass: "fc-pad-b-min" }, [
          _vm._v(_vm._s(_vm.$t("m.whether-account")))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "fc-color-gray-light" }, [
          _vm._v(_vm._s(_vm.$t("m.answer-whether-account")))
        ]),
        _vm._v(" "),
        _c("hr", { staticClass: "hr-line" }),
        _vm._v(" "),
        _c("p", { staticClass: "fc-pad-b-min" }, [
          _vm._v(_vm._s(_vm.$t("m.no-account")))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "fc-color-gray-light" }, [
          _vm._v(_vm._s(_vm.$t("m.answer-no-account")))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "fc-color-gray-light" }, [
          _vm._v(_vm._s(_vm.$t("m.recharge-money")))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "fc-color-gray-light" }, [
          _vm._v(_vm._s(_vm.$t("m.recharge-time")))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "fc-color-gray-light" }, [
          _vm._v(_vm._s(_vm.$t("m.recharge-shot")))
        ]),
        _vm._v(" "),
        _c("hr", { staticClass: "hr-line" }),
        _vm._v(" "),
        _c("p", { staticClass: "fc-pad-b-min" }, [
          _vm._v(_vm._s(_vm.$t("m.recharge-wrong")))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "fc-color-gray-light" }, [
          _vm._v(_vm._s(_vm.$t("m.answer-recharge-wrong")))
        ]),
        _vm._v(" "),
        _c("hr", { staticClass: "hr-line" }),
        _vm._v(" "),
        _c("p", { staticClass: "fc-pad-b-min" }, [
          _vm._v(_vm._s(_vm.$t("m.refund")))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "fc-color-gray-light" }, [
          _vm._v(_vm._s(_vm.$t("m.answer-refund")))
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5082d29e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5082d29e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href","audio":"src"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/asks.vue
// module id = null
// module chunks = 